<template>
  <transition name="van-slide-up" appear @afterEnter="afterEnter">
    <div ref="messageItem" class="message-item" @click="handleATagJump">
      <div v-if="isService" class="message-item-service">
        <em class="icon iconfont icon-service"></em>
        <div class="cont">
          <p
            class="cont-msg"
            v-html="isAiBot ? showAiBotMessage : decorateServiceMsg(msg)"
            @click="handleAiBotMsgClick"
          ></p>

          <div v-if="getImgAndVideoSequence.length > 0" class="cont-img">
            <span
              v-for="item in getImgAndVideoSequence"
              :key="item.url"
              class="cont-wrap"
            >
              <van-image
                radius="6px"
                width="58px"
                height="58px"
                fit="cover"
                :show-loading="true"
                lazy-load
                :src="item.url"
                @click="previewImage(item.type)"
              >
                <template v-slot:loading>
                  <van-loading type="spinner" size="20" />
                </template>
              </van-image>
              <em v-show="item.type === 'video'" class="cont-duration">
                {{ item.duration }}
              </em>
            </span>
          </div>
        </div>
      </div>
      <div v-else class="message-item-player">
        <div class="cont">
          <template v-if="orderId && title">
            <p class="cont-id">[ NO.{{ showOrderId }} ]</p>
            <p class="cont-title">{{ title }}</p>
          </template>
          <p
            class="cont-msg"
            v-html="isAiBot ? showAiBotMessage : msg"
            @click="handleAiBotMsgClick"
          ></p>
          <div v-if="getImgAndVideoSequence.length > 0" class="cont-img">
            <span
              v-for="item in getImgAndVideoSequence"
              :key="item.url"
              class="cont-wrap"
            >
              <van-image
                class="cont-img-item"
                radius="6px"
                width="58px"
                height="58px"
                fit="cover"
                :show-loading="true"
                lazy-load
                :src="item.url"
                @click="previewImage(item.type)"
              >
                <template v-slot:loading>
                  <van-loading type="spinner" size="20" />
                </template>
              </van-image>
              <em v-show="item.type === 'video'" class="cont-duration">
                {{ item.duration }}
              </em>
            </span>
          </div>
        </div>
        <em class="icon iconfont icon-player"></em>
      </div>
    </div>
  </transition>
</template>

<script>
import { ImagePreview } from 'vant';
import bridge from '@utiles/bridge';

export default {
  name: 'MessageItem',
  props: {
    isService: {
      type: Boolean,
      default: false
    },
    orderId: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    msg: {
      type: String,
      default: ''
    },
    imgList: {
      type: Array,
      default: () => []
    },
    videoList: {
      type: String,
      default: ''
    },
    videoDurations: {
      type: String,
      default: ''
    },
    isLastMsg: {
      type: Boolean,
      default: false
    },
    videoPreviewPic: {
      type: Array,
      default: () => []
    },
    picAndVideoSequence: {
      type: String,
      default: ''
    },
    isAiBot: {
      type: Boolean,
      default: false
    },
    aiBotMessage: {
      type: Object,
      default: () => {}
    },
    isSupportCreateAibotOrder: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    formatImgList() {
      if (this.imgList?.length && this.imgList.length > 0) {
        return this.imgList
          .filter(item => {
            return !!item;
          })
          .map(item => {
            return {
              url: item
            };
          });
      } else {
        return [];
      }
    },
    formatVideoList() {
      let list = [];
      let videoDurationsList = [];
      const videoList = this.videoList?.split('|') || [];

      try {
        videoDurationsList = JSON.parse(this.videoDurations);
      } catch (e) {
        console.error(e);
        videoDurationsList = [];
      }
      if (
        videoList.length === videoDurationsList.length &&
        videoList.length === this.videoPreviewPic?.length
      ) {
        videoList.forEach((item, index) => {
          list.push({
            url: this.videoPreviewPic[index],
            videoPath: item,
            duration: videoDurationsList[index]
          });
        });
      }

      return list;
    },
    getImgAndVideoSequence() {
      try {
        if (!this.picAndVideoSequence) return this.formatImgList;
        const picAndVideoSequence = JSON.parse(this.picAndVideoSequence);
        if (!picAndVideoSequence?.length) return this.formatImgList;
        const sequence = [];
        const mergeList = [...this.formatImgList, ...this.formatVideoList];
        picAndVideoSequence.forEach((item, index) => {
          const mergeListItem = mergeList.find(cItem => {
            if (cItem?.videoPath) {
              return cItem?.videoPath?.includes(item);
            }
            return cItem?.url?.includes(item);
          });
          if (mergeListItem) {
            sequence.push({
              type: mergeListItem?.videoPath ? 'video' : 'image',
              url: mergeListItem?.url,
              duration: mergeListItem?.duration || '0:00'
            });
          }
        });
        return sequence;
      } catch (e) {
        console.error(e);
      }
      return [];
    },
    showOrderId() {
      if (this.isSupportCreateAibotOrder) {
        return `A${this.orderId}`;
      }
      return this.orderId;
    },
    showAiBotMessage() {
      if (this.isAiBot) {
        return this.replaceMarkdownImagesWithHtml(
          this.mixImageInContent({
            content: this.aiBotMessage?.content || '',
            message_files: this.aiBotMessage?.message_files || []
          })
        );
      }
      return '';
    }
  },
  methods: {
    afterEnter(el) {
      setTimeout(() => {
        if (this.isLastMsg) {
          el &&
            el?.scrollIntoView({
              behavior: 'smooth'
            });
        }
      }, 100);
    },
    previewImage(type) {
      if (type === 'video') return;
      const images = this.getImgAndVideoSequence
        .filter(item => {
          // 视频功能上传前缺少字段标识，统一当做为图片
          return item?.type === 'image' || item?.type === void 0;
        })
        .map(item => item.url);
      if (images.length === 0) return;
      ImagePreview({
        images,
        startPosition: 0,
        closeable: true
      });
    },
    decorateServiceMsg(msg) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(msg, 'text/html');
      const links = doc.querySelectorAll('a');

      links.forEach(link => {
        link.removeAttribute('target');
        const hrefValue = link.getAttribute('href');
        link.setAttribute('data-url', hrefValue);
        link.setAttribute('href', 'javascript:;');
      });
      return doc.body.innerHTML;
    },
    handleATagJump(e) {
      const dataset = e?.target?.dataset;
      const tagName = e?.target?.tagName;
      if (tagName === 'A' && dataset?.url) {
        bridge.runInsdk()
          ? bridge.callSdkMethod('openWebView', {
              url: dataset.url,
              loginDir: 0,
              appendParams: 1
            })
          : window.open(dataset.url, '_blank');
      }
    },
    handleAiBotMsgClick(e) {
      const target = e.target.closest('.j-question-screenshot-detail-page');
      if (target) {
        ImagePreview({
          images: [target.src],
          startPosition: 0,
          closeable: true
        });
      }
    },
    mixImageInContent({ content, message_files }) {
      if (!content) return '';
      if (!message_files || !message_files?.length) return content;
      return `${content}\n${message_files
        .map(item => `![screenshot](${item.url})`)
        ?.join('\n')}`;
    },
    replaceMarkdownImagesWithHtml(markdownText) {
      const regex = /!\[([^\]]*)\]\(([^)]*)\)/g;
      return markdownText.replace(regex, (_, altText, imageUrl) => {
        return `<img src="${imageUrl}" alt="${altText}" style="width: auto; height: 100px;margin-right: 10px" class="j-question-screenshot-detail-page" />`;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.message-item {
  box-sizing: border-box;
  width: 100%;
  margin: 0 auto 18px;
  &-service,
  &-player {
    display: flex;
    align-items: flex-start;

    .icon {
      font-size: 24px;
      color: var(--main-color);
    }
    .cont {
      box-sizing: border-box;
      min-width: 120px;
      max-width: 100%;
      padding: 10px;
      font-size: 16px;
      line-height: 21px;

      &-msg {
        word-wrap: break-word;
        -webkit-user-select: text;
        user-select: text;
        white-space: pre-wrap;
      }
      &-img {
        margin-top: 10px;
        margin-right: -8px;

        .van-image {
          margin: 0 8px 8px 0;
        }

        &-item {
          margin: 5px;
        }
      }
      &-wrap {
        position: relative;
        display: inline-block;
      }
      &-duration {
        position: absolute;
        bottom: 13px;
        right: 8px;
        height: 24px;
        padding: 0 6px;
        background-color: rgba(0, 0, 0, 0.7);
        font-size: 12px;
        line-height: 24px;
        text-align: center;
        color: #fff;
        border-radius: 10px 0 6px 0;
      }
    }
  }

  &-service {
    justify-content: flex-start;
    .icon {
      margin-right: 16px;
    }
    .cont {
      background-color: var(--main-color);
      border-radius: 6px 6px 30px 6px;
      color: var(--text-on-main-bg-color);
    }
  }
  &-player {
    justify-content: flex-end;
    .icon {
      margin-left: 16px;
    }
    .cont {
      background-color: var(--block-bg-light-color);
      border-radius: 6px 6px 6px 30px;

      &-id {
        font-size: 12px;
        color: var(--placeholder-color);
      }
      &-title {
        margin-bottom: 8px;
        padding-bottom: 8px;
        font-weight: bold;
        font-size: 16px;
        line-height: 22px;
        border-bottom: 1px dotted var(--border-color);
      }
    }
  }
}
</style>
<style lang="scss">
.cont-msg {
  a {
    color: var(--text-on-main-bg-color);
    text-decoration: underline;
    text-underline-offset: 0.2em;
  }
  strong {
    font-weight: bold;
  }
  em {
    font-style: italic;
  }
}
</style>
